"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditProductButton = void 0;
const React = require("react");
const react_1 = require("react");
const colors_1 = require("../../../../../../types/colors");
const Button_1 = require("../../../../../../components/base/atoms/Button");
const TSalesOrderItemType_1 = require("../../../types/TSalesOrderItemType");
const standardSizes_1 = require("../../../../../../types/standardSizes");
const SalesOrderItemBuilt_1 = require("../../../models/SalesOrderItemBuilt");
const cloneModelObject_1 = require("../../../../../../apis/spg/util/cloneModelObject");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "EditProductButton");
const EditProductButton = ({ salesOrderItem, index, setSalesOrderItemBuiltDetails }) => {
    const editBuiltProduct = (0, react_1.useCallback)((salesOrderItem, index) => {
        if (salesOrderItem.type !== TSalesOrderItemType_1.TSalesOrderItemType.Built) {
            return;
        }
        // need to rebuild the sales order item otherwise data will be wrong
        const salesOrderItemBuilt = salesOrderItem;
        const newSalesOrderItemBuilt = new SalesOrderItemBuilt_1.SalesOrderItemBuilt(salesOrderItemBuilt.productBlueprint);
        // rebuild selections and availability
        newSalesOrderItemBuilt.initialise(salesOrderItemBuilt.selectedProducts);
        // need update quantity otherwise it will be reset to one
        newSalesOrderItemBuilt.quantity = salesOrderItem.quantity;
        // update current edit built product with new details
        setSalesOrderItemBuiltDetails({
            index,
            salesOrderItemBuilt: (0, cloneModelObject_1.cloneModelObject)(newSalesOrderItemBuilt)
        });
    }, []);
    return (React.createElement(Button_1.Button, { className: css(""), variant: "secondary", size: standardSizes_1.TStandardSizes.Small, status: colors_1.TColorVariants.Info, icon: "th-list", onClick: () => editBuiltProduct(salesOrderItem, index) }, "edit"));
};
exports.EditProductButton = EditProductButton;
//# sourceMappingURL=index.js.map